import React from 'react';
import { getNextMidNightAtTimeZone } from '@benzinga/date-utils';

export const useResetAtMidNight = (callback: () => void) => {
  const setTimeoutHolder = React.useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const resetAtMidNight = React.useCallback(() => {
    const nextMidnight = getNextMidNightAtTimeZone('America/New_York');
    const currentTime = Date.now();
    const nextTimeout = nextMidnight - currentTime;
    setTimeoutHolder.current = setTimeout(() => {
      callback();
      resetAtMidNight();
    }, nextTimeout);
  }, [callback]);

  React.useEffect(() => {
    resetAtMidNight();
    return () => clearTimeout(setTimeoutHolder.current);
  }, [resetAtMidNight]);
};
